"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxWithLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var react_hook_form_1 = require("react-hook-form");
var MBCheckbox_1 = require("../MBCheckbox");
function CheckboxWithLabel(_a) {
    var label = _a.label, name = _a.name, control = _a.control, style = _a.style, loading = _a.loading, onChange = _a.onChange, setEdited = _a.setEdited;
    var onCheckboxChange = function (controllerOnChange) {
        return function (e) {
            setEdited && setEdited(true);
            controllerOnChange(e.target.checked);
            onChange && onChange(e.target.checked);
        };
    };
    return (jsx_runtime_1.jsx(Container, __assign({ style: style }, { children: jsx_runtime_1.jsx(react_hook_form_1.Controller, { render: function (_a) {
                var controllerOnChange = _a.onChange, onBlur = _a.onBlur, value = _a.value, name = _a.name;
                return (jsx_runtime_1.jsx(MBCheckbox_1.MBCheckbox, { onBlur: onBlur, onChange: onCheckboxChange(controllerOnChange), checked: value, name: name, disabled: loading, labelText: label }, void 0));
            }, name: name, control: control }, void 0) }), void 0));
}
exports.CheckboxWithLabel = CheckboxWithLabel;
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var templateObject_1;
//# sourceMappingURL=CheckboxWithLabel.js.map